import { lazy } from 'react';

// Lazy load all page components
// This improves initial load performance by only loading components when needed
const AvailableFlows = lazy(() => import('./AvailableFlows'));
const ConnectParams = lazy(() => import('./ConnectParams'));
const CopyEntity = lazy(() => import('./CopyEntity'));
const FlowSources = lazy(() => import('./FlowSources'));
const FlowTargets = lazy(() => import('./FlowTargets'));
const FlowV2Connectors = lazy(() => import('./FlowV2Connectors'));
const Loading = lazy(() => import('./Loading'));
const SyncSchedule = lazy(() => import('./SyncSchedule'));
const UploadFile = lazy(() => import('./UploadFile'));
const FieldMapTransferList = lazy(() => import('./FieldMapTransferList'));
const FieldMapSelector = lazy(() => import('./FieldMapSelector'));
const FieldMapSelectorV2 = lazy(() => import('./FieldMapSelectorV2'));
const EntityConfig = lazy(() => import('./EntityConfig'));

// Export lazy-loaded components
export {
  AvailableFlows,
  ConnectParams,
  CopyEntity,
  FlowSources,
  FlowTargets,
  FlowV2Connectors,
  Loading,
  SyncSchedule,
  UploadFile,
  FieldMapTransferList,
  FieldMapSelector,
  FieldMapSelectorV2,
  EntityConfig
};
